<template>
    <svg
        class="icon"
        :class="{ 'icon-spin': spin }"
        :style="`height: ${size || '1.5rem'}; width: ${size || '1.5rem'};`"
    >
        <use :href="`#${icon}`" />
    </svg>
</template>

<script setup lang="ts">
interface Props {
    icon: string;
    spin?: boolean;
    size?: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.icon {
    fill: currentColor;
    height: 2rem;
    width: 2rem;

    &.icon-spin {
        animation: icon-spin 2s infinite linear;
    }
}

.icon-viewbox {
    width: unset;
    height: unset;
}

@keyframes icon-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(359deg);
    }
}
</style>
